import React from 'react';
import {UserContextType} from 'components/triggers/UserContextType';

export default class UserIsSharedConditionComponent extends React.Component {
  render() {
    const {contextType} = this.props;
    return (
      <div>
        {contextType === UserContextType.USER && (
          <span>
            <span className="condition-action" onClick={this.props.onClick}>
              [users who have this rule enabled, excluding me]
            </span>{' '}
            review a call
          </span>
        )}
        {contextType === UserContextType.CALL && contextType === UserContextType.CALLER && (
          <span>
            is from{' '}
            <span className="condition-action" onClick={this.props.onClick}>
              [a user that has this rule enabled, excluding me]
            </span>
          </span>
        )}
      </div>
    );
  }
}
